export function getCustomer(data) {
    return new Promise((resolve, reject) => {
		let { getCustomerRequest, getCustomerError, getCustomerResult } = this.props;

		this.doAction(
			this.WEB_REQUEST_URL + 'get_customer',
			this.createBundle(
				'get_customer',
				{ customer: data },
				this.GET,
				getCustomerRequest,
                (result) => {
                    getCustomerResult(result)
                    resolve(result)
                },
                (error) => {
                    getCustomerError(error)
                    reject(error)
                }
			)
		);
	})
}
